import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-massive-actions-modal',
  templateUrl: './massive-actions-modal.component.html',
  styleUrls: ['./massive-actions-modal.component.scss']
})
export class MassiveActionsReportModalComponent implements OnInit {

  selectAttachments: boolean = false;
  downloadAtt: boolean = false;
  dataLabel:string = "";
  labelSelectAll:string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<MassiveActionsReportModalComponent>,
  ) { 
    this.dataLabel = this.data.dataLabel;
    this.labelSelectAll = this.data.labelSelectAll;
    this.selectAttachments = this.data.selectAttachments;
  }

  ngOnInit(): void {
  }

  onContinue(selectedAll: boolean){
    this.dialogRef.close({
      selectedAll: selectedAll,
      selectedList: this.data.selectedList,
      downloadAttachments: this.downloadAtt
    });
  }

  downloadAttachments(e){
    this.downloadAtt = e.checked;
  }

}
